import { render, staticRenderFns } from "./AddTreatment.vue?vue&type=template&id=350f67f6"
import script from "./AddTreatment.vue?vue&type=script&lang=js"
export * from "./AddTreatment.vue?vue&type=script&lang=js"
import style0 from "./AddTreatment.vue?vue&type=style&index=0&id=350f67f6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports